import React from "react";
import PayoutWorkspace from "./PayoutWorkspace";
const ReportPayout = props => <PayoutWorkspace mode="report" history={props.history} />;
export default ReportPayout;
